import { Organization } from "../interfaces/AccessInterfaces";

const BASE_URL_AUTH = process.env.REACT_APP_MAZELOG_AUTH_BASE_URL;

export async function getTransporterClients(oauth: string, tranposrterUserName: string): Promise<Organization[]> {
    
    const url = `${BASE_URL_AUTH}/transporters/transporter_allocation/clients?transporter=${tranposrterUserName}`;

    const response = await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        accept: 'application/json',
        "Authorization": oauth
      }
    });
    
    if (!response.ok)
        throw new Error(`Response status: ${response.status}`);

    const json = await response.json();

    return json;
}
